const prefix = ''

export const devicesUrls = {
  'devices.list': `${prefix}/devices`,
  'devices.register': `${prefix}/devices/register`,
}
